/** Reload the configuration file. */
export function reloadConfig() {
    return new Promise<void>((resolve, reject) => {
        // load the config file
        const head = document.getElementsByTagName("head")[0];
        const script = document.createElement("script");
        const preventCacheTimestamp = new Date().getTime();
        script.src = `/config.js?t=${preventCacheTimestamp}`;

        // wait for the script to load which will update the window.__runtime_configuration object
        script.onload = () => resolve();
        script.onerror = (err) => {
            console.warn("Failed to reload configuration file", err);
            reject(new Error("Failed to reload configuration file", { cause: err }));
        };
        head?.appendChild(script);
    });
}
